// extracted by mini-css-extract-plugin
export default {"background":"spinner_background__yjSjL","ldsRing":"spinner_ldsRing__VBZ5D"};